import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import AuditPage from "@/pages/AuditPage";
import SummaryPage from "@/pages/SummaryPage";
import AdminInbox from "@/pages/AdminInbox";
import ProfilePage from "@/pages/ProfilePage";
import ActionCenter from "@/pages/ActionCenter";

const SmoothScroll = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    window.__lenis = lenis;
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);
  useEffect(() => { window.__lenis?.scrollTo(0, { immediate: true }); window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AuthProvider>
          <SmoothScroll />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/registro" element={<AuthPage mode="register" />} />
            <Route path="/panel" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/auditoria" element={<ProtectedRoute><AuditPage /></ProtectedRoute>} />
            <Route path="/resumen/:id" element={<ProtectedRoute><SummaryPage /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute admin><AdminInbox /></ProtectedRoute>} />
            <Route path="/perfil" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
            <Route path="/plan-de-accion" element={<ProtectedRoute><ActionCenter /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="bottom-right" theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
